import { render } from "./EstadoRecepcionList.vue?vue&type=template&id=20c3c81e&scoped=true"
import script from "./EstadoRecepcionList.vue?vue&type=script&lang=js"
export * from "./EstadoRecepcionList.vue?vue&type=script&lang=js"

import "./EstadoRecepcionList.vue?vue&type=style&index=0&id=20c3c81e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/jeanInformatico-management-system/jeanInformatico-management-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20c3c81e"]])

export default __exports__